import { useState, useReducer, useEffect, CSSProperties } from "react";
import "../styles/SearchTable.scss";
import { Table, Form, Dropdown, Input, Pagination, Loader } from 'semantic-ui-react';
import _ from 'lodash';
import DatePicker from "react-datepicker";
import { CarrierData } from "../services/ShipService/types";

type Props = {
    tableData: CarrierData[],
    loading: boolean,
    nextStep: Function
}

function tableReducer(state: any, action: any) {
    switch (action.type) {
        case 'CHANGE_SORT':
            if (state.column === action.column) {
                return {
                    ...state,
                    data: state.data.slice().reverse(),
                    direction: state.direction === 'ascending' ? 'descending' : 'ascending',
                }
            }

            return {
                column: action.column,
                data: _.sortBy(state.data, [action.column]),
                direction: 'ascending',
            }
        default:
            throw new Error()
    }
}

const getCarriers = (tableData: any) => {
    let outputCarriersArr: any = [];
    if (tableData != null && tableData.length > 0) {
        let initialCarriersArr = tableData.map((route: any) => route.carrierName)
        let uniqueCarriersArr = initialCarriersArr.filter((value: any, index: number, array: any[]) => array.indexOf(value) === index);
        uniqueCarriersArr.forEach((carrier: any) => outputCarriersArr.push({ text: carrier, value: carrier }))
    }

    return outputCarriersArr;
}

interface CarrierTableData {
    text: string,
    value: string | number
}
interface styles {
    headerCell: CSSProperties,
    tCell: CSSProperties,
    tCellLink: CSSProperties,
}

const SearchParcelTable = (props: Props) => {

    const { tableData, loading, nextStep } = props
    const [carriers, setCarriers] = useState<Array<CarrierTableData>>([])
    useEffect(() => setCarriers(getCarriers(tableData)), [tableData]);
    const [state, dispatch] = useReducer(tableReducer, {
        column: null,
        data: tableData,
        direction: null,
    })
    const { column, data, direction } = state;
    const [query, setQuery] = useState<string>("");
    const [date, setDate] = useState<Date>(new Date());
    const [filters, setFilters] = useState<Array<string>>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [itemsPerPage,] = useState<number>(15);

    const setSelected = (e: any, { value }: any) => setFilters(value)
    const headerArr: string[] = tableData !== null ? tableData.length > 0 && Object.keys(tableData[0]) : [];

    try {
        headerArr.forEach(header => {
            const newHeader: string = header.replace('_', ' ')
            const arr: string[] = newHeader.split(" ")
            for (var i = 0; i < arr.length; i++) {
                arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
            }
            const capHeader: string = arr.join(" ");
            headerArr.push(capHeader)

        });

        const search = (data: any) => {
            const keys = Object.keys(data[0])
            return data.filter((item: any) => keys.some(key => item[key].toString().toLowerCase().includes(query.toLowerCase())));
        }

        const style: styles = {
            headerCell: {
                backgroundColor: "#2d8fc4",
                color: "white",
                border: "0.5px solid #ddd",
                fontSize: '1rem',
                textAlign: 'center',
            },
            tCell: {
                fontSize: '1rem',
                textAlign: 'center',
            },
            tCellLink: {
                fontSize: '1rem',
                textAlign: 'center',
                color: '#3b3be4',
                cursor: 'pointer'
            },
        }

        const Headers: any = () => {
            return (
                Object.keys(tableData[0]).map((col, idx) => {
                    const newHeader: string = col.replace('_', ' ')
                    const arr: string[] = newHeader.split(" ")
                    for (var i = 0; i < arr.length; i++) {
                        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
                    }
                    const capHeader: string = arr.join(" ").replace(/([A-Z])/g, ' $1').trim();
                    return (
                        <Table.HeaderCell
                            key={idx}
                            style={style.headerCell}
                            sorted={column === col ? direction : null}
                            onClick={() => dispatch({ type: 'CHANGE_SORT', column: col })}
                        >
                            {capHeader}
                        </Table.HeaderCell>
                    )
                })
            )
        }
        const handlePageChange = (e: any, { activePage }: any) => {
            setCurrentPage(activePage);
        }
        let currentPageData = search(data).slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
        return (
            <div className="app">
                <Form >
                    <Form.Group>
                        <Input icon='search' style={{ width: '400px' }} placeholder='Search...' onChange={(e: React.ChangeEvent<HTMLInputElement>) => setQuery(e.target.value)} /> &nbsp;&nbsp;
                        <Dropdown style={{ width: '200px' }} placeholder='All Carriers' fluid multiple selection options={carriers} id="dropdown" onChange={setSelected} />&nbsp;&nbsp;
                        <div id="date-picker" style={{ marginLeft: '5px', width: '390px' }} >
                            {/* <DatePicker selected={date} onChange={(date) => setDate(date)} />  May add back at later date */}
                            <i>Showing orders from last 30 days</i>
                        </div>
                    </Form.Group>
                </Form>
                <div style={{ width: '100%', marginTop: '10px', textAlign: 'center' }}>
                    {!loading ?
                        <>
                            <Table sortable celled >
                                <Table.Header>
                                    <Table.Row>
                                        <Headers />
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {currentPageData.map((row: any, idx: any) => {
                                        let bgc;
                                        if (row.exceptions) {
                                            if (row.exceptions.includes("Missed")) { bgc = '#C8B6FC' }
                                            else if (row.exceptions.includes("Late")) { bgc = '#FCC2C2' }
                                            else if (row.exceptions.includes("Early")) { bgc = '#F5B642' }
                                            else bgc = '#fff'
                                        }

                                        if (row.carrierName) {
                                            if (filters.length === 0) {
                                                return (
                                                    <Table.Row key={idx} style={{ backgroundColor: bgc, }}>
                                                        {Object.keys(row).map((col, idx) => {
                                                            if (col === 'carrierId') {
                                                                return <Table.Cell key={idx} style={style.tCellLink} onClick={() => nextStep(row[col])}> {row[col].toString()}</Table.Cell>
                                                            } else {
                                                                return <Table.Cell key={idx} style={style.tCell}> {row[col].toString()}</Table.Cell>
                                                            }
                                                        })}
                                                    </Table.Row>
                                                )
                                            } else {
                                                return (
                                                    filters.includes(row['carrierName']) &&
                                                    <Table.Row key={idx} style={{ backgroundColor: bgc }}>
                                                        {Object.keys(row).map(col => {
                                                            if (col === 'carrierId') {
                                                                return <Table.Cell style={style.tCellLink} onClick={() => nextStep()}> {row[col].toString()}</Table.Cell>
                                                            } else {
                                                                return <Table.Cell style={style.tCell}> {row[col].toString()}</Table.Cell>
                                                            }
                                                        })}
                                                    </Table.Row>
                                                )
                                            }
                                        } else {
                                            return (
                                                <Table.Row key={idx} style={{ backgroundColor: bgc }}>
                                                    {Object.keys(row).map(col => {
                                                        return <Table.Cell style={style.tCell}> {row[col].toString()}</Table.Cell>
                                                    })}
                                                </Table.Row>
                                            )
                                        }
                                    })}
                                </Table.Body>
                            </Table>
                            <Pagination
                                activePage={currentPage}
                                onPageChange={handlePageChange}
                                siblingRange={1}
                                pointing
                                secondary
                                totalPages={Math.ceil(data.length / itemsPerPage)}
                            />
                        </>
                        :
                        <div> <Loader style={{ marginTop: '20px' }} active size='massive'>Loading</Loader></div>
                    }
                </div>
            </div>
        );

    } catch (error) {
        console.log(error)
    }
}

export default SearchParcelTable